import React, { Fragment } from "react";

import { connect } from "react-redux";
import classes from "./Paggination.module.css";
import * as actionCreators from "../../../Store/actions/index";

const Paggination = (props) => {
    const pagginationElements = [];
    if (props.paggination.pagination_info) {
        const pageCount = props.paggination.pagination_info.pages_count;
        const pageNum = props.paggination.pagination_info.page;
        for (let count = 1; count < pageCount + 1; count++) {
                const pageElement = (
                    <Fragment key={count}>
                        <input type='radio'
                            value={count}
                            checked={count === +pageNum ? true : false}
                            name='page'
                            id={`page${count}`}
                            onChange={(event) => {
                                if (props.dealer) {
                                    props.onGetDealerPosts(props.dealer, event.target.value)
                                }
                                else {
                                    props.onGetVehicleItems(props.vehicleType, event.target.value, props.brand)
                                }
                            }} />
                        <label htmlFor={`page${count}`} className={classes.PageNum}>
                            {count}
                        </label>
                    </Fragment>);
                pagginationElements.push(pageElement)
        }
    }
    let paggeinationClasses = classes.Paggination;
    if (props.itemsLoading) {
        paggeinationClasses = `${classes.Paggination} ${classes.DiplayNone}`
    }

    return (

        <div className={paggeinationClasses}>
            {pagginationElements}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        vehicleType: state.SearchP.vehicleType,
        itemsLoading: state.SearchP.itemsLoading
    }
};

const mapDispatchToprops = dispatch => {
    return {
        onGetVehicleItems: (type, pageNum, brand) => { dispatch(actionCreators.getVehicleItems(type, pageNum, brand)) },
        onGetDealerPosts: (dealerId, pageNum) => { dispatch(actionCreators.getDealerPosts(dealerId, pageNum)) }
    }
}

export default connect(mapStateToProps, mapDispatchToprops)(Paggination);